// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"94315750","455":"5eb5a699","977":"356a8419"}[chunkId] + ".chunk.js";
};